<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
            <a-input :read-only="params.isShow" placeholder="请输入姓名" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入姓名' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系方式">
            <a-input :read-only="this.params.isShow" placeholder="请输入联系方式" v-decorator="[
          'phoneNumber',
          {rules: [{ required: true, message: '请输入联系方式' }],initialValue:data.phoneNumber}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登录名">
            <a-input :read-only="this.params.isShow" placeholder="请输入登录名" v-decorator="[
          'userName',
          {rules: [{ required: true, message: '请输入登录名' }],initialValue:data.userName}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row class="form-row" v-if="!(this.params.id)">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="密码">
            <a-input type="password" :read-only="this.params.isShow" placeholder="请输入密码" v-decorator="[
          'password',
          {rules: [{ required: true, message: '请输入密码' }],initialValue:data.password}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
            <a-radioGroup :disabled="this.params.isShow" placeholder="请选择状态" v-decorator="[
          'isActive',
          {initialValue:data.isActive,rules: [{ required: true, message: '请选择状态' }]}]">
              <a-radio value="1">启用</a-radio>
              <a-radio value="0">禁用</a-radio>
            </a-radioGroup>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色">
            <a-radioGroup :disabled="this.params.isShow" placeholder="请选择用户角色" v-decorator="[
          'userType',
          {initialValue:data.userType,rules: [{ required: true, message: '请选择用户角色' }]}]">
              <a-radio value="1">员工</a-radio>
              <a-radio value="2">经销商</a-radio>
            </a-radioGroup>
          </a-form-item>
        </a-col>
      </a-row>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";

const defaultData = {
  id: 0,
  name: "",
  phoneNumber: "",
  userName: "",
  isActive: "1",
  password: "",
  dealerId: 0,
  roleNames: [],
  userType:"2"
};
export default {
  name: "hp-manager-page-dealer-user-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      allRoles: [],
      checkedRoles: [],
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },

  async mounted() {
    if (this.params.id) {
      this.getdetailUser();
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    onRoleChange(checkedValues) {
      this.checkedRoles = checkedValues;
    },
    async getdetailUser() {
      this.loading = true;
      let result = await api.GetDealerUser({ Id: this.params.id });
      if (result) {
        this.data = result;
        this.data.dealerId = this.data.dealerId;
        this.data.name = this.data.name;
        this.data.userName = this.data.userName;
        this.data.phoneNumber = this.data.phoneNumber;
        this.data.isActive = (this.data.isActive ? 1 : 0) + "";
        this.data.userType=this.data.userType+"";
      }
      this.loading = false;
    },
    async submitHandler() {
      await api.AddOrUpdateUser(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        userName: value.userName,
        phoneNumber: value.phoneNumber,
        password: value.password,
        userType: value.userType,
        roleNames: [],
        dealerId: this.params.dealerId,
        isActive: parseInt(value.isActive) == 1
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.params.id > 0) {
          data = await api.UpdateDealerUser(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.AddDealerUser(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Basic/Dealer/AddDealerUser.vue